<div class="centered profile-menu-container">
  <div [matMenuTriggerFor]="profileMenu" class="centered avatar-name-container" aria-label="account">
    <mat-icon class="avatar-icon" aria-hidden="true">account_circle</mat-icon>
    <span class="user_name">{{username}}</span>
  </div>
  <mat-menu #profileMenu="matMenu">
    <button mat-menu-item [routerLink]="['/app/profile']">Profile</button>
    <button mat-menu-item (click)="logout()">Logout</button>
  </mat-menu>
  <button mat-icon-button class="example-icon" aria-label="System settings" matTooltip="System settings (Global Variables)"
          [routerLink]="['/app/admin/global-variables']">
    <mat-icon svgIcon="settings-icon"></mat-icon>
  </button>
</div>